import { render, staticRenderFns } from "./AnchorLinkedBlocks.vue?vue&type=template&id=28cc68d3&scoped=true&"
import script from "./AnchorLinkedBlocks.vue?vue&type=script&lang=ts&"
export * from "./AnchorLinkedBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./AnchorLinkedBlocks.vue?vue&type=style&index=0&id=28cc68d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc68d3",
  null
  
)

export default component.exports